





















import Vue from 'vue'
import { db } from '@/firebase'
import { BlogPost } from '@/types'
import { convertDataFromApi } from '@/utils'

export default Vue.extend({
    name: 'BlogList',
    data: () => ({
        posts: [] as BlogPost[],
    }),
    mounted() {
        db.collection('fl_content')
            .where('_fl_meta_.schema', '==', 'eventBlog')
            .orderBy('_fl_meta_.lastModifiedDate', 'desc')
            .get()
            .then((snapshot) => {
                this.posts = snapshot.docs.map((doc) => convertDataFromApi(doc.data(), false) as BlogPost)
            })
    },
    methods: {
        toDateString(date: Date) {
            const options = { year: 'numeric', month: 'long', day: 'numeric' }
            return date ? date.toLocaleDateString(this.$i18n.locale, options) : ''
        },
    },
})
